import HeaderBar from "../../../Components/UI/headerbar";
import SliderTab from "../components/SliderTab";

const SlidersPage = () => {

  return (
    <div className="container-fluid">
      <HeaderBar title="التسويق" content="إدارة الكوبونات والعروض والبانرات." />

      <div className="mt-4">
        <SliderTab />
      </div>
    </div>
  );
};

export default SlidersPage;
